import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import PopupHoraReservada from "./Popup/popupHoraReservada";
import { FormContext } from "../context/FormContext";
import { useNavigate } from "react-router-dom";
import ConfirmacionReservaPopup from "./ConfirmacionReservaPopup";
import PopupFormAtencionCliente from "./Popup/popupFormAtencionCliente";
import PopupHoraTerminosCondiciones from "./Popup/popupTerminosCondiciones";
import PopupDatosPersonales from "./Popup/popupDatosPersonales";
import PopupTerminosCondicionesPeru from "./Popup/popupTerminosCondicionesPeru";

const Autorizaciones = ({ handleResumenSubmit }) => {
  const { updateFormData, formData } = useContext(FormContext);
  const [recibirPromocionesMail, setRecibirPromocionesMail] = useState(
    formData.DatosPersonales.int_optin || false
  );
  const [autorizarDatos, setAutorizarDatos] = useState(
    formData.DatosPersonales.int_usodatopersonal
  );
  const [terminosCondiciones, setTerminosCondiciones] = useState(
    formData.DatosPersonales.int_usoadicional
  );

  // Estado para controlar qué popup está abierto
  const [activePopup, setActivePopup] = useState(null);

  // Función para abrir el popup
  const openPopup = (popupType) => (e) => {
    e.preventDefault(); // Previene la recarga de la página
    setActivePopup(popupType);
  };

  // Función para cerrar el popup
  const closePopup = () => {
    setActivePopup(null);
  };

  // Actualizar el contexto cuando cambia recibirPromocionesMail
  const handleRecibirPromocionesMailChange = (checked) => {
    setRecibirPromocionesMail(checked);
    updateFormData({
      DatosPersonales: {
        ...formData.DatosPersonales, // Conservamos el resto de los datos
        int_optin: checked, // Actualizamos solo el valor de int_usodatopersonal
      },
    });
  };

  // Actualizar el contexto cuando cambia autorizarDatos
  const handleAutorizarDatosChange = (checked) => {
    setAutorizarDatos(checked);
    updateFormData({
      DatosPersonales: {
        ...formData.DatosPersonales, // Conservamos el resto de los datos
        int_usodatopersonal: checked, // Actualizamos solo el valor de int_usodatopersonal
      },
    });
  };

  // Actualizar el contexto cuando cambia autorizarDatos
  const handleTerminosCondicionesChange = (checked) => {
    setTerminosCondiciones(checked);
    updateFormData({
      DatosPersonales: {
        ...formData.DatosPersonales, // Conservamos el resto de los datos
        int_usoadicional: checked, // Actualizamos solo el valor de int_usodatopersonal
      },
    });
  };

  // Configuración de URLs personalizadas para cada cadena
  const [promocionesUrl , setPromocionesUrl] = useState("");
  const [datosPersonalesUrl , setDatosPersonalesUrl] = useState("");

  const urlsAutorizaciones = {
    eco: {
      promociones: "https://www.econopticas.cl/promociones",
      datosPersonales: "https://www.econopticas.cl/customer/account/create/",
    },
    gmo: {
      promociones: {
        pe: "https://gmo.com.pe/promociones",
        cl: "https://www.gmo.cl/terminos-promociones",
        co: "https://gmo.com.co/promociones",
        ec: "https://gmo.com.ec/promociones"
      },
      datosPersonales: {
        pe: "https://gmo.com.pe/tyc-ecommerce",
        cl: "https://www.gmo.cl/terminos-datos",
        co: "https://gmo.com.co/tyc-ecommerce",
        ec: "https://gmo.com.ec/tyc-ecommerce"
      },
    },
    opv: {
      promociones: "https://www.opv.cl/institucional#promociones",
      datosPersonales: "https://www.opv.cl/Institucional/terminos-condiciones",
    },
  };

  const pais = formData?.pais;
  const cadena = formData?.cadena;

  useEffect(() => {
    // Obtener las URLs basadas en la cadena actual
    if (formData?.cadena === "gmo") {
      setPromocionesUrl(urlsAutorizaciones[formData.cadena]?.promociones[formData?.pais] || "#");
      setDatosPersonalesUrl(urlsAutorizaciones[formData.cadena]?.datosPersonales[formData?.pais] || "#");
    }else{
      setPromocionesUrl(urlsAutorizaciones[formData.cadena]?.promociones || "#");
      setDatosPersonalesUrl(urlsAutorizaciones[formData.cadena]?.datosPersonales || "#");
    }
  }, [formData?.cadena, formData?.pais]);

  return (
    <form onSubmit={(e) => e.preventDefault()} className="form-add-contact">
      <div className="row">
        <div className="col-md-6 col-8 pads30 pads15-768 mb40 align-self-center">
          <p className="text-switch monts-sb blue-bord">
            Inscribirme para recibir promociones vía mail, según condiciones
            disponibles{" "}
            <a href={promocionesUrl} target="_blank" rel="noopener noreferrer">
              <strong>aquí</strong>
            </a>
          </p>
        </div>
        <div className="col-md-6 col-4 mb40 text-md-start text-end align-self-center">
          <p className="text-switch monts-sb">
            No &nbsp;
            <input
              type="checkbox"
              id="switch-mail"
              name="mail-selection"
              checked={recibirPromocionesMail}
              onChange={(e) =>
                handleRecibirPromocionesMailChange(e.target.checked)
              }
              className="switch-mail"
            />
            <label htmlFor="switch-mail"> </label>
            &nbsp; Sí
          </p>
        </div>

        <div className="col-md-6 col-8 pads30 pads15-768 mb40 align-self-center">
          <p className="text-switch monts-sb blue-bord">
            Autorizo el uso de mis datos personales, según condiciones
            disponibles{" "}
            <a
              href={datosPersonalesUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>aquí</strong>
            </a>{" "}
            {/* <a href="#" onClick={openPopup("popupHoraTerminosCondiciones")}>
              aquí
            </a>{" "} */}
            <br />
            <span>Acepto Términos y Condiciones*</span>
          </p>
        </div>
        <div className="col-md-6 col-4 mb40 text-md-start text-end align-self-center">
          <p className="text-switch monts-sb">
            No &nbsp;
            <input
              type="checkbox"
              id="switch-subs"
              name="subscription-selection"
              checked={autorizarDatos}
              onChange={(e) => handleAutorizarDatosChange(e.target.checked)}
              className="switch-subs"
            />
            <label htmlFor="switch-subs"> </label>
            &nbsp; Sí
          </p>
        </div>

        {(pais === "pe" && cadena === "gmo") && (
          <>
            <div className="col-md-6 col-8 pads30 pads15-768 mb40 align-self-center">
              <p className="text-switch monts-sb blue-bord">
                Autorizo el uso de mis datos para fines adicionales, disponible
                {" "}
                <a href="#" onClick={openPopup("popupTerminosCondicionesPeru")}>
                  <strong>aquí</strong>
                </a>{" "}
                <br />
                <span>Acepto Términos y Condiciones*</span>
              </p>
            </div>
            <div className="col-md-6 col-4 mb40 text-md-start text-end align-self-center">
              <p className="text-switch monts-sb">
                No &nbsp;
                <input
                  type="checkbox"
                  id="switch-terms"
                  name="terms-selection"
                  checked={terminosCondiciones}
                  onChange={(e) => handleTerminosCondicionesChange(e.target.checked)}
                  className="switch-terms"
                />
                <label htmlFor="switch-terms"> </label>
                &nbsp; Sí
              </p>
            </div>
          </>
        )}

        <div className="col-12 text-center">
          <p className="text-switch monts-sb">
            <i>
              Al continuar con la reserva, declaro que, como la persona que hace
              la reserva, tengo 18 años o más, estoy autorizado a reservar en
              nombre de cualquier persona indicada en este formulario y acepto
              los términos y condiciones y política de privacidad
            </i>
          </p>
        </div>

        <div className="col-12 text-md-end text-center mt20">
          <input
            type="submit"
            value="RESERVAR EXAMEN DE LA VISTA"
            className={`step-contact-button 
              ${formData?.cadena === "eco" ? "eco-theme-button" : ""}
              ${formData?.cadena === "gmo" ? "gmo-theme-button" : ""}
              `}
            
            style={{ display: "inline-block" }}
            onClick={handleResumenSubmit}
          />
        </div>
      </div>

      {/* Popups */}
      {activePopup === "popupDatosPersonales" && (
        <PopupDatosPersonales onClose={closePopup} />
      )}
      {activePopup === "popupHoraTerminosCondiciones" && (
        <PopupHoraTerminosCondiciones
          filePath="popup-datospersonales.pdf"
          onClose={closePopup}
        />
      )}
      {activePopup === "popupTerminosCondicionesPeru" && (
        <PopupTerminosCondicionesPeru onClose={closePopup} />
      )}
    </form>
  );
};

const Resumen = ({ onVolver, onResumenSeleccionado }) => {
  const { formData } = useContext(FormContext);
  const [showPopup, setShowPopup] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [interesadoId, setInteresadoId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [codeError, setCodeError] = useState("1");
  const [showPopupHoraReservada, setshowPopupHoraReservada] = useState(false);
  const [flagAtencionCO, setflagAtencionCO] =	 useState(false);
  const [numeroCita, setNumeroCita] = useState("");
  const [numeroCliente, setNumeroCliente] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    // Datos del contexto mostrados en el resumen final
    // console.log("Datos en el RESUMEN:", formData);
  }, [formData]);

  const handleResumenSubmit = () => {
    // Datos del formulario al enviar la reserva
    // console.log("submit formadata", formData);
    if (!formData.DatosPersonales.int_usodatopersonal) {
      alert("Debes autorizar el uso de tus datos personales para continuar.");
      return; // Detiene la ejecución si el usuario no autoriza
    }
    // SOLO validar int_usoadicional si es Perú y GMO
    if (formData.pais === "pe" && formData.cadena === "gmo") {
      if (!formData.DatosPersonales.int_usoadicional) {
        alert("Debes aceptar los términos y condiciones para continuar.");
        return;
      }
    }else{
      formData.DatosPersonales.int_usoadicional = false;
    }

    const postResumen = {
      accion: 1,
      cnv_codigo: formData.DatosPersonales.cnv_codigo,
      int_email: formData.DatosPersonales.int_email,
      int_optin: formData.DatosPersonales.int_optin ? 1 : 0,
      rsa_fecha: formData.fechaSeleccionada,
      cfg_codigo: formData.TiendaSeleccionada.cfg_codigo,
      nombre_convenio: formData.DatosPersonales.nombre_convenio,
      nombre_servicio: formData.PropocitoCita,
      int_codigo: 0,
      rsa_codigo: 0,
      tpc_codigo: formData.tpc_codigo,
      tpo_codigo: formData.DatosPersonales.tpo_codigo,
      int_fechanac: formData.DatosPersonales.fechanacimiento,
      int_pnombre: formData.DatosPersonales.int_pnombre,
      int_snombre: formData.DatosPersonales.int_snombre || "",
      int_amaterno: formData.DatosPersonales.int_amaterno || "",
      int_apaterno: formData.DatosPersonales.int_apaterno,
      int_telefono: formData.DatosPersonales.int_telefono,
      int_domicilio: formData.DatosPersonales.int_domicilio,
      int_nrodocidentidad: formData.DatosPersonales.int_nrodocidentidad,
      int_usodatopersonal: formData.DatosPersonales.int_usodatopersonal ? 1 : 0,
      flag_uso: formData.flag_uso || 0,
      int_usoadicional: formData.DatosPersonales.int_usoadicional ? 1 : 0,
    };

    // Datos procesados para enviar al endpoint de reserva
    // console.log("post resumen ENDPOINT", postResumen);
    
    setIsLoading(true); // Mostrar indicador de carga
    axios
      .post(`${process.env.REACT_APP_API_URL_AGENDAR_CITA}`, postResumen, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_BEARER_TOKEN}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const { message, success } = response.data;
        // Respuesta del servidor al crear la reserva
        // console.log("Respuesta del endpoint reserva", response);
        // console.log("response.data", response.data);
        // console.log("response.data", response.data.success);
        if (!success) {
          // Reserva no exitosa - mostrar mensaje de error
          // console.log("entre al sucess", success);
          setResponseMessage(message);
          setshowPopupHoraReservada(true);
        } else {
          // ID de reserva generado exitosamente
          // console.log("ID_reserva", response?.data?.id_reserva?.id_reserva);
          setNumeroCita(response?.data?.id_reserva?.id_reserva); // Número de cita mock, reemplaza con data real
          setShowPopup(true); // Mostrar popup
          setNumeroCliente(response?.data?.id_cliente); // Número de cliente mock, reemplaza con data real
          if (formData?.cadena === "gmo" && formData?.pais === "co") {
            setflagAtencionCO(true);
          }
        }
      })
      .catch((error) => {
        // Error al procesar la solicitud de reserva
        console.error("Error al registrar la reserva:", error?.response?.data);
        setResponseMessage(error?.response?.data?.message);
        setshowPopupHoraReservada(true);
      })
      .finally(() => {
        setIsLoading(false); // Ocultar indicador de carga
      });
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleAddMoreInfo = () => {
    // Redirección a formulario de anamnesis adicional
    // console.log("Lógica para agregar más información");
    setInteresadoId(376783);
    setShowPopup(false); // Cerrar el popup al agregar más información
    navigate(`/anamnesis?interesadoId=${376783}`); // Redirige a /anamnesis
  };

  // Función para formatear la fecha seleccionada
  const formatDate = (date) => {
    if (!date) return {};
    const parsedDate = new Date(date);
    return {
      month: parsedDate.toLocaleString("es-ES", { month: "long" }),
      day: parsedDate.getDate(),
      year: parsedDate.getFullYear(),
    };
  };

  const formattedDate = formData.fechaSeleccionada
    ? formatDate(formData.fechaSeleccionada)
    : null;

  return (
    <div className="col-md-9 pads0-768" id="contact-info">
      <div className="row contact-info-container">
        {isLoading && (
          <div className="loading-overlay">
            <div className="spinner"></div>
          </div>
        )}

        <div className="col-12 pads0">
          <div className="col-12 text-center mb20">
            <h3 
           className={`h3-less
             ${formData?.cadena === "eco" ? "eco-theme-text" : ""}
             ${formData?.cadena === "gmo" ? "gmo-theme-text" : ""}
             `}
            >
              Resumen de la reserva
              </h3>
          </div>

          <div className="col-12 pads0" id="patient-resume">
            <div className="row mb20" id="patient-selected-store">
              <div className="col-12 pads0 mb20">
                <div className="resume-bar">
                  <b>Tienda Seleccionada</b>
                </div>
              </div>

              <div className="col-md-6 pads0 mb10-768">
                <div className="row">
                  <div className="col-12">
                    <h6 className="monts-b upper">
                      {formData?.TiendaSeleccionada?.nombre}
                    </h6>
                    <p className="mb0">
                      {formData?.TiendaSeleccionada?.direccion}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 align-self-center text-center">
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                    formData?.TiendaSeleccionada?.direccion
                  )}`}
                >
                  <a
                    href={
                      formData.TiendaSeleccionada.cfg_latitud &&
                      formData.TiendaSeleccionada.cfg_longitud // Verificar que ambas coordenadas existan
                        ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                            `${formData.TiendaSeleccionada.cfg_latitud.replace(
                              ",",
                              "."
                            )},${formData.TiendaSeleccionada.cfg_longitud.replace(
                              ",",
                              "."
                            )}`
                          )}`
                        : "#"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      if (
                        !formData.TiendaSeleccionada.cfg_latitud ||
                        !formData.TiendaSeleccionada.cfg_longitud
                      ) {
                        e.preventDefault(); // Evitar que el enlace intente navegar si no hay coordenadas válidas
                        // Advertencia: coordenadas de tienda no disponibles para mapa
                        console.warn("Las coordenadas no están disponibles.");
                      }
                    }}
                  >
                    {" "}
                    <p className="text-switch monts-sb blue-bord upper inline-b mb0">
                      Cómo Llegar
                    </p>
                  </a>
                </a>
              </div>
            </div>
            <div className="row" id="patient-resume-1">
              <div className="col-12 pads0 mb20">
                <div className="resume-bar">
                  <b>
                    Reserva de
                    <span className="desc-ovw-patient-name">
                      &nbsp;{formData?.DatosPersonales?.int_pnombre}
                    </span>
                    <span className="desc-ovw-patient-last">
                      &nbsp;{formData?.DatosPersonales?.int_apaterno}
                    </span>
                  </b>
                </div>
              </div>
              <div className="col-md-6 pads0 mb20 mb0-768">
                <div className="row">
                  <div className="col-12 mb20">
                    <h6 className="monts-b upper">Propósito de la visita</h6>
                    <p className="mb0 desc-ovw-type">
                      {formData?.PropocitoCita}
                    </p>
                  </div>
                  <div className="col-12 mb20 mb0-768">
                    <h6 className="monts-b upper">Fecha y Hora</h6>
                    <p className="mb0 desc-ovw-date">
                      <span className="date-month">
                        {formData.fechaSeleccionada}&nbsp;
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-md-6 mb20">
                <h6 className="monts-b upper">Información del paciente</h6>
                <p className="mb0">
                  <span className="desc-ovw-patient-name">
                    <strong>Nombre:</strong>{" "}
                    {formData?.DatosPersonales?.int_pnombre}&nbsp;
                  </span>
                  <span className="desc-ovw-patient-last">
                    {formData?.DatosPersonales?.int_apaterno}
                  </span>
                </p>
                <p className="mb0">
                  <span className="desc-ovw-patient-birth">
                    <strong>Fecha de nacimiento:</strong> &nbsp;
                    {formData?.DatosPersonales?.fechanacimiento}
                  </span>
                </p>
                <p className="mb0">
                  <span className="desc-ovw-patient-mail">
                    <strong>Correo Electrónico:</strong> &nbsp;
                    {formData?.DatosPersonales?.int_email}
                  </span>
                </p>
                <p className="mb0">
                  <span className="desc-ovw-patient-phone">
                    <strong>Teléfono de Contacto:</strong> &nbsp;
                    {formData?.DatosPersonales?.int_telefono}
                  </span>
                </p>
                <p className="mb0">
                  <span className="desc-ovw-patient-dni">
                    <strong>{formData?.DatosPersonales?.tipo_documento}:</strong> &nbsp;
                    {formData?.DatosPersonales?.int_nrodocidentidad}
                  </span>
                </p>
                {formData?.DatosPersonales?.cnv_codigo !== 0 && (
                  <p className="mb0">
                    <span className="desc-ovw-patient-conv">
                      <strong> Convenio:</strong>&nbsp;
                      {formData?.DatosPersonales?.nombre_convenio}
                    </span>
                  </p>
                )}
              </div>
            </div>
          </div>

          <Autorizaciones handleResumenSubmit={handleResumenSubmit} />
        </div>
      </div>

      {/* Indicador de carga */}
      {isLoading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}

      {/* Popup de éxito */}
      {showPopup && (
        (flagAtencionCO) ? (
          <PopupFormAtencionCliente
            numeroCita={numeroCita}
            numeroCliente={numeroCliente}
            onClose={handleClosePopup}
          />
        ) : (
          <ConfirmacionReservaPopup
            numeroCita={numeroCita}
            onClose={handleClosePopup}
          />
        )
      )}

      {showPopupHoraReservada && (
        <PopupHoraReservada message={responseMessage} />
      )}
    </div>
  );
};

export default Resumen;
